var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-page-loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":200,"width":10}},[_c('img',{attrs:{"src":require("@/assets/images/common/homePad_logo_ico.svg"),"alt":"homePad logo","width":"140px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }